<template>
  <h1 class="header">Font Preview</h1>
  <p class="scala">--- FONT PREVIEW ---</p>
  <div class="button-container">
    <button v-for="font in fontList" :class="{ active: selectedFont === font.fontFamily }"
      :style="{ fontFamily: font.fontFamily }" :key="font.fontFamily" @mousedown="changeFont(font.fontFamily)">
      <h3>{{ font.name }}</h3>
    </button>
  </div>
  <textarea class="textarea font-preview" :style="{ fontFamily: selectedFont }" ref="textarea"
    maxlength="130" rows="3" aria-label="Font Preview Input Field" v-model="text" @focus="playOpenSound">
  </textarea>
</template>

<script>
import selectSound from "@/assets/audio/select.mp3";
import openSound from "@/assets/audio/open.mp3";
export default {
  name: 'FontPreview',
  data() {
    return {
      text: "THERE ARE MANY WORLDS, BUT THEY SHARE THE SAME SKY. ONE SKY, ONE DESTINY.",
      selectedFont: 'KHTitle',
      fontList: [
        { name: 'KHMenu', fontFamily: 'KHMenu' },
        { name: 'KHGummi', fontFamily: 'KHGummi' },
        { name: 'KHTitle', fontFamily: 'KHTitle' },
        { name: 'KHData', fontFamily: 'KHData' },
        { name: 'KHSCALA', fontFamily: 'KHScala' },
        { name: 'KHSCALA', fontFamily: 'KHScalaScript' },
      ],
    };
  },
  mounted() {
    this.adjustTextareaHeight();
  },
  watch: {
    text() {
      this.adjustTextareaHeight();
    },
    selectedFont() {
      this.adjustTextareaHeight();
    },
  },
  methods: {
    changeFont(font) {
      if (this.selectedFont !== font) {
        this.selectedFont = font;
        const selectAudio = new Audio(selectSound);
        selectAudio.play();
      }
    },
    adjustTextareaHeight() {
      this.$nextTick(() => {
        const textarea = this.$refs.textarea;
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
      });
    },
    playOpenSound() {
      const openAudio = new Audio(openSound);
      openAudio.play();
    },
  },
};
</script>

<style scoped>
button {
  padding: 0.5em 1.5em;
}
.font-preview {
  font-size: calc(1.25em + 2.5vw);
  font-weight: normal;
  text-align: center;
  resize: none;
  min-height: 7em;
  padding: 5vw;
  color: var(--white);
  background: linear-gradient(to bottom, var(--black), var(--black) 50%, var(--indigo) 50%, var(--indigo));
  background-size: 100% 5px;
  border: none;
  outline: 2px solid var(--blue-light);
  filter: drop-shadow(0 0 0.25em var(--indigo))
          drop-shadow(0 0 0.25em var(--indigo));
}
@media screen and (min-width: 1200px) {
  .font-preview {
    border-radius: 0.125em;
  }
}
.font-preview:hover {
  outline: 2px solid var(--white);
}
.textarea {
  width: 100%;
  box-sizing: border-box;
  overflow-y: hidden;
}
.textarea:focus {
  .font-preview {
    border-top: 2px solid var(--white);
    border-bottom: 2px solid var(--white);
  }
}
</style>